import { defineStore } from 'pinia'
import { homeService } from '@/services/homeService'
import errorService from "@/services/errorService";

export const useHomeStore = defineStore('home', {
  state: () => ({
    informations: {
      current_balance: 0,
      publisher: {
        chart: {
          visits: [],
        }
      },
      redator: {
        chart: {
          visits: [],
        }
      },
      total_earnings: 0,
      version: null,
    },
    filter: {},
  }),

  actions: {
    async getInformations() {
      try {
        const response = await homeService.fetchInformations(this.filter);
        this.informations = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },
  }
});